<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <filters></filters>
        <report></report>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Report/Filters'
import List from './Report/List'
export default {
  components: {
    filters: Filters,
    report: List
  },
  mounted () {
    document.title = 'Build Report :: PBN360 by Aphex Media'
  }
}
</script>
<style>
#filters .pretty-input {
  border: 1px solid #e5e6e7;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Overview/Feed.vue